import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

/**
 * Alinea el estilo de la barra de estado nativa (Capacitor) con el tema efectivo de la UI.
 * En @capacitor/status-bar: Style.Dark = texto/iconos claros sobre fondo oscuro; Style.Light = texto oscuro sobre fondo claro.
 */
@Injectable({ providedIn: 'root' })
export class StatusBarThemeService {
  private ultimoModoOscuro: boolean | null = null;

  /**
   * @param esModoOscuro true cuando la app está en tema oscuro (clases dark / ion-palette-dark).
   */
  sincronizarConModoOscuro(esModoOscuro: boolean): void {
    void this.sincronizarConModoOscuroAsync(esModoOscuro);
  }

  private async sincronizarConModoOscuroAsync(esModoOscuro: boolean): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    if (this.ultimoModoOscuro === esModoOscuro) {
      return;
    }
    try {
      await StatusBar.setStyle({
        style: esModoOscuro ? Style.Dark : Style.Light,
      });
      this.ultimoModoOscuro = esModoOscuro;
    } catch {
      this.ultimoModoOscuro = null;
    }
  }
}
